// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__yl3k1","contact":"Footer_contact__oICuX","contactText":"Footer_contactText____MYE","copyright":"Footer_copyright__g3z6w"};